import React from 'react';
import { Text, StyleSheet } from 'react-native';

import { chargeDataFragment } from 'apollo/queries/autogenerate/operations';
import { isCancellationCharge } from 'shared/modules/usage/utils/charge-utils';

export default function ChargeMessage({
  charge,
}: {
  charge?: chargeDataFragment;
}) {
  let title = '※ご注意';
  let subtitle =
    '翌月一回払いを除き、商品の種類又は品質に関して契約の内容に適合しない場合や、役務の未提供などを理由に支払いを止めることができる場合があります。その場合は、ペイディカスタマーサポートへご連絡ください。ただし、予め販売店と交渉を行なうよう努めていただくものとします｡';

  const cancellationCharge = isCancellationCharge(charge);

  if (cancellationCharge) {
    title = '※キャンセル金額について';
    subtitle =
      'キャンセル金額は、分割払いの合計金額から、すでにお支払い済みの金額と、ご請求が確定している金額を差し引いた金額になります。';
  }

  return (
    <>
      <Text style={[styles.text, styles.title]}>{title}</Text>
      <Text style={styles.text}>{subtitle}</Text>
    </>
  );
}

const styles = StyleSheet.create({
  text: {
    fontFamily: 'Hiragino Sans',
    fontSize: 13,
    lineHeight: 16,
    color: '#586065',
  },
  title: {
    fontWeight: '700',
    marginBottom: 8,
  },
});
